import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  height: 100dvh;
  width: 100vw;
  padding: ${({ theme }) => theme.spacing(6)};
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0 auto;
  max-width: 100%;
`;

export const BodyContent = styled.div`
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(8)};

  min-width: 0;
  width: 32rem;
  max-width: 32rem;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2.5)};
`;

export const Logo = styled.img`
  align-self: center;
  flex-shrink: 0;
  width: 72px;
`;

export const Description = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.body1)};

  margin: 0;
  padding: 0;

  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: center;
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
  width: 100%;
`;

export const CopyableUrl = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.caption)};

  margin: 0;
  padding: ${({ theme }) => theme.spacing(3)};

  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  border-radius: ${({ theme }) => theme.spacing(2)};

  color: ${({ theme }) => theme.palette.text.secondary};
  overflow-wrap: anywhere;
  user-select: all;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};
`;

export const SignUpButton = styled.button`
  padding: 0;
  border: none;
  background: none;

  color: ${({ theme }) => theme.palette.primary.main};
  font: inherit;
  cursor: pointer;
`;
